import * as Colors from 'ui-library/Colors';

export const ITEM_SIZE_SIDE_NAVBAR = 54;
export const PADDING_SIDEPANEL = 12;

export const ZINDEX_NAVBAR = 1000; // Keep in sync with `@zindex-navbar`
export const ZINDEX_BUFFER_CTRL_F = 58; // Keep in sync with `@zindex-bufferCtrlF`
const ZINDEX_SIDEPANEL = 60; // Keep in sync with `@zindex-sidepanel`
export const ZINDEX_INPUT_BUBBLE = ZINDEX_SIDEPANEL + 1; // 61
export const ZINDEX_SIDE_NAVBAR = 65; // Keep in sync with `@zindex-sideNavbar`
export const ZINDEX_SIMPLE_TABLE_FROZEN_HEADER = 2;
// The layout header needs to be above the header of any tables in the layout's body so that the box shadow
// of the header is not obscured by the headers of any tables in the page's content.
export const ZINDEX_TAB_LAYOUT_HEADER = ZINDEX_SIMPLE_TABLE_FROZEN_HEADER + 1;
// When drag-and-dropping an Insights block, it should be rendered on top of content in other blocks,
// including table headers.
export const ZINDEX_DND_CANVAS_DRAGGED_BLOCK = ZINDEX_SIMPLE_TABLE_FROZEN_HEADER + 1;
// From bootstrap's @zindex-modal
export const ZINDEX_MODAL = 1050;
// higher than modal-dialog (1050), inspired by bootstrap's @zindex-tooltip
export const ZINDEX_FLOATING_UI = 1060;

/**
 * Common z-index values to promote interoperable UI components; maintain in sync with @zindex-* LESS variables
 */
export enum ZIndexRole {
  MODAL = 1050, // @zindex-modal
  DROPDOWN = 1051, // @zindex-absolute-dropdown-container
  DATE_PICKER = 1052, // @zindex-ui-datepicker
  TOOLTIP = 1060, // @zindex-tooltip
  NOTIFICATION = 1060, // @zindex-notifications
}

export const BORDER_MAJOR = Colors.SILVER;

// Matches @font-size-base
export const FONT_SIZE_BASE = 14;

// Matches @line-height-small
export const LINE_HEIGHT_SMALL = 1.5;

// Matches @padding-small-vertical
export const PADDING_SMALL_VERTICAL = 5;

// Matches @font-size-small
export const FONT_SIZE_SMALL = Math.ceil(FONT_SIZE_BASE * 0.85);
// Matches @input-height-small
export const INPUT_HEIGHT_SMALL =
  Math.floor(FONT_SIZE_SMALL * LINE_HEIGHT_SMALL) + PADDING_SMALL_VERTICAL * 2;

// Matches u-input-line-height
export const INPUT_LINE_HEIGHT = {
  lineHeight: `${INPUT_HEIGHT_SMALL}px`,
  verticalAlign: 'middle',
};

// Matches @border-radius--default
export const BORDER_RADIUS_DEFAULT = 4;
